import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decrypt } from '../../../../Functions/authentication';


const HeaderNav = () => {

    const [logo, setLogo] = useState(null);

    useEffect(() => {
        let t = localStorage.getItem('tenant') && decrypt(localStorage.getItem('tenant'), 'lstenant');
        setLogo(t?.logo);
    }, [])

    return (
        <header className="d-flex justify-content-between mr-md-5 ml-md-5 mt-3">
            <div className="logo-header mostion ">
                <Link to="/"><img src={logo} className="logo" alt="img" /></Link>
            </div>
            <Link to="/login" className="text-light">
                <div className="site-button">
                    Login
                </div>
            </Link>
        </header>
    );
};

export default HeaderNav;